import { findFile } from '@efdigital/ll-admin-v2/data/builders/content/files';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export default class LibraryFoldersFileRoute extends Route {
  @service declare store: Store;

  async model(params: { file_id: string }) {
    const file = (await this.store.request(findFile(params.file_id))).content
      .data;

    return { file };
  }
}
